import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "semantic-ui-less/semantic.less";
//import "react-bootstrap";
import { Provider } from "react-redux";
import store from "./store";

// eslint-disable-next-line react/no-deprecated
ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById("root")
);
